<po-page-list #poPageListComponent
  p-title="Faturamento Guarita {{this.guaritaNome}}"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-page-slide
  #pageSlide
  p-title="Faturamento Pedido {{this.pedidoSelecionado.CC5NUM}} {{this.complemento}}"
  p-size="auto"
>
  @if(pedidoSelecionado.CC5EHCOMP !== 'S'){
    <div>
      <po-lookup
        class="po-md-3"
        name="CC5TRANSP"
        [(ngModel)]="pedidoSelecionado.CF2TRANSP"
        p-field-label="CA4NOME"
        p-field-value="CA4COD"
        p-label="Transportadora"
        [p-columns]="columnsTransportadoraFilters"
        [p-field-format]="fieldFormaterTransportadoraFilters"
        [p-filter-service]="transportadoraService"
        [p-advanced-filters]="advancedTransportadoraFilters"
        [p-literals]="{ modalTitle: 'Transportadora' }"
        [p-required]="true"
      ></po-lookup>
      <po-input
        class="po-md-2"
        name="CPLACA"
        [(ngModel)]="pedidoSelecionado.CPLACA"
        p-label="Placa Veículo / UF"
        [p-maxlength]="13"
        [p-required]="true"
        p-mask="AAA-9N99 / AA"
      ></po-input>
      <po-datepicker
        class="po-md-2"
        name="DC5DTCORTE"
        [(ngModel)]="pedidoSelecionado.DC5DTCORTE"
        p-format="dd/mm/yyyy"
        [p-iso-format]="formatExtended"
        p-label="Data do Corte"
      ></po-datepicker>
      <po-input
        class="po-md-2"
        name="CF2ROMANEI"
        [(ngModel)]="pedidoSelecionado.CF2ROMANEI"
        p-label="Nº Romaneio"
        [p-maxlength]="30"
        [p-required]="true"
      ></po-input>
      <po-number
        class="po-md-3"
        name="NC5REMSIMB"
        [(ngModel)]="pedidoSelecionado.NC5REMSIMB"
        p-label="Remessa Simbólica ref NF"
        [p-disabled]="pedidoSelecionado.CC5TIPO != 'B'"
      ></po-number>
    </div>
  }

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="400"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="colunasItens"
    [p-items]="pedidoSelecionado.items"
    p-spacing="small"
  >
    <ng-template  p-table-cell-template let-column="column" let-item="row" p-property="NQTDENT">
      <po-decimal
        [(ngModel)]="item.NQTDENT"
        name="NQTDENT{{item.CC6ITEM}}"
        (p-change)="verificaValores()"
      ></po-decimal>
    </ng-template>
  </po-table>
  <po-button
    p-label="Faturar"
    class="po-md-12"
    (p-click)="confirmaFaturarPedido()"
  ></po-button>
</po-page-slide>


<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-6"
      p-label="Guarita"
      name="CC5GUARITA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5GUARITA"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="guaritaColumnsFilters"
      [p-field-format]="guaritaFieldFormaterFilters"
      [p-filter-service]="zprLookupService"
      [p-advanced-filters]="guaritaAdvancedFilters"
      [p-literals]="{ modalTitle: 'Guarita' }"
      [p-required]="true"
    ></po-lookup>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5EMISSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de"
    ></po-datepicker>
    <po-datepicker
      class="po-md-3"
      name="DC5EMISSAO_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5EMISSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CC5NUM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5NUM"
      p-label="Código Pedido"
      [p-maxlength]="6"
    ></po-input>
  </form>
</po-modal>

<po-modal #modalStatusFaturamento p-title="Status Faturamento" [p-primary-action]="atualizaStatusFaturamento">
  <po-widget>
    1. Status Pedido
    <po-tag
      p-value="{{statusFaturamento.NREGSC9 !== 0?'Liberado':'Erro'}}"
      p-color="{{statusFaturamento.NREGSC9 !== 0?'color-10':'color-07'}}"
    ></po-tag>
  </po-widget>

  <po-widget>
    2. Nota Fiscal &nbsp;
    <po-tag
      p-value="{{statusFaturamento.CC9NFISCAL !== ''?'Gerada':'Pendente'}}"
      p-color="{{statusFaturamento.CC9NFISCAL !== ''?'color-10':'color-07'}}"
    ></po-tag>
  </po-widget>

  <po-widget>
    3. Transmissão de Nota &nbsp;
    <po-tag
      p-value="{{statusFaturamento.CF3CODRET !== ''?'Enviada':'Pendente'}}"
      p-color="{{statusFaturamento.CF3CODRET !== ''?'color-10':'color-07'}}"
    ></po-tag>
  </po-widget>

  <po-widget>
    4. Confirmação da Nota &nbsp;
    <po-tag
      p-value="{{(statusFaturamento.CF3CODRET == 'M' && statusFaturamento.CF3CODRSEF == '100')?'Confirmada':(statusFaturamento.CF3CODRET == 'M' && statusFaturamento.CF3CODRSEF != '100')?'Não autorizada - Retorno do Sefaz Código {{statusFaturamento.CF3CODRSEF}}':'Pendente'}}"
      p-color="{{(statusFaturamento.CF3CODRET == 'M' && statusFaturamento.CF3CODRSEF == '100')?'color-10':(statusFaturamento.CF3CODRET == 'M' && statusFaturamento.CF3CODRSEF != '100')?'color-08':'color-07'}}"
    ></po-tag>
  </po-widget>

  <po-widget>
    <b>Número da Nota:</b> {{statusFaturamento.CC9NFISCAL}}<br />
    <b>Série da Nota:</b> {{statusFaturamento.CC9SERIENF}}<br />
    <b>Chave da Nota:</b> {{statusFaturamento.CF3CHVNFE}}<br />
    <div class="po-row">
      <po-button
        class="po-md-12 po-mt-2"
        (p-click)="gerarDanfe()"
        p-label="Gerar Danfe"
        [p-disabled]="btnGerarDanfeDisabled"
      ></po-button>
    </div>
  </po-widget>

</po-modal>

<po-modal #listaTitulosModal p-title="Lista Títulos em Aberto" p-size="lg">
  <po-table class="po-sm-12 po-md-12 po-lg-12 po-mb-3"
    [p-height]="400"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="colunasTitulos"
    [p-items]="listaTitulosCliente.items"
    p-spacing="small">
  </po-table>
  <po-info p-label="Saldo total" p-value="{{valorTotalTitulos| currency : 'BRL'}}"> </po-info>
</po-modal>
